import React from 'react';
import CookieHead from '../../components/CookieHead/CookieHead';
import CookieBody from '../../components/CookieBody/CookieBody';

function CookiePolicy() {
	return (
		<div>
			<CookieHead />
			<CookieBody />
		</div>
	);
}

export default CookiePolicy;
